import {
  InputNameSignIn,
  InputNameSignUp,
  InputProps,
  InputTypeSignUp,
  InputTypeSignIn
} from "../types/index";

export const SIGNUP: InputProps<InputNameSignUp, InputTypeSignUp>[] = [
  {
    name: "fullName",
    type: "text",
    placeholder: "Full Name",
    autoComplete: "name",
    label: "Full Name"
  },
  {
    name: "email",
    type: "email",
    placeholder: "example@.com",
    autoComplete: "email",
    label: "Email"
  },
  {
    name: "password",
    type: "password",
    placeholder: "Password",
    autoComplete: "new-password",
    label: "Password"
  },
  {
    name: "confirmPassword",
    type: "password",
    placeholder: "Confirm Password",
    autoComplete: "new-password",
    label: "Confirm Password"
  }
];

export const SIGNIN: InputProps<InputNameSignIn, InputTypeSignIn>[] = [
  {
    name: "email",
    type: "email",
    placeholder: "Email",
    autoComplete: "email",
    label: "Email"
  },
  {
    name: "password",
    type: "password",
    placeholder: "Password",
    autoComplete: "new-password",
    label: "Password"
  }
];
